import { Route } from "react-router-dom";
import UrlsConfig from "@/config/UrlsConfig";
import { lazy } from "react";

const ReferenceBookCategoriesOfSamples = lazy(() => import("@/pages/ReferenceBooks/Lists/Testing/CategoriesOfSamples/ReferenceBookCategoriesOfSamples"));
const ReferenceBookDNATests = lazy(() => import("@/pages/ReferenceBooks/Lists/Testing/TestTypes/ReferenceBookDNATests"));
const ReferenceBookDefinitionOfSKUs = lazy(() => import("@/pages/ReferenceBooks/Lists/Testing/DefenitionOfSKUs/ReferenceBookDefenitionOfSKUs"));
const ReferenceBookOrderStatuses = lazy(() => import("@/pages/ReferenceBooks/Lists/Testing/OrderStatuses/ReferenceBookOrderStatuses"));
const ReferenceBookAttributeRuleForNParticipants = lazy(() => import("@/pages/ReferenceBooks/Lists/Testing/AttributeRuleForNParticipants/ReferenceBookAttributeRuleForNParticipants"))
const ReferenceBookAttributeSelectionRules = lazy(() => import("@/pages/ReferenceBooks/Lists/Testing/AttributeSelectionRules/ReferenceBookAttributeSelectionRules"))
const ReferenceBookFamilySteps = lazy(() => import("@/pages/ReferenceBooks/Lists/Testing/FamilySteps/ReferenceBookFamilySteps"));
const ReferenceBookDescribeKinshipSurvey = lazy(() => import("@/pages/ReferenceBooks/Lists/Testing/DescribeKinshipSurvey/ReferenceBookDescribeKinshipSurvey"))
const ReferenceBookPedigrees = lazy(() => import("@/pages/ReferenceBooks/Lists/Testing/Pedigrees/ReferenceBookPedigrees"));
const ReferenceBookAudience = lazy(() => import("@/pages/ReferenceBooks/Lists/Testing/Audience/ReferenceBookAudience"));
const ReferenceBookState = lazy(() => import("@/pages/ReferenceBooks/Lists/Testing/State/ReferenceBookState"));
const ReferenceBookQuestionType = lazy(
    () => import("@/pages/ReferenceBooks/Lists/Testing/QuestionType/ReferenceBookQuestionType"),
);
const ReferenceBookReviewPeriod = lazy(
    () => import("@/pages/ReferenceBooks/Lists/Testing/ReviewPeriod/ReferenceBookReviewPeriod"),
);
const ReferenceBookAssignmentType = lazy(
    () => import("@/pages/ReferenceBooks/Lists/Testing/AssignmentType/ReferenceBookAssignmentType"),
);
const ReferenceBookRecipient = lazy(
    () => import("@/pages/ReferenceBooks/Lists/Testing/Recipient/ReferenceBookRecipient"),
);
const ReferenceBookPreviousAssignment = lazy(
    () => import("@/pages/ReferenceBooks/Lists/Testing/PreviousAssignment/ReferenceBookPreviousAssignment"),
);
const ReferenceBookUnit = lazy(() => import("@/pages/ReferenceBooks/Lists/Testing/Unit/ReferenceBookUnit"));

const urlsConfig = new UrlsConfig();

export function referenceBookTestingRoutes() {
    return (
        <>
            <Route
                path={urlsConfig.referenceBookCategoriesOfSamples.to}
                element={<ReferenceBookCategoriesOfSamples/>}
            />
            <Route
                path={urlsConfig.referenceBookDNATests.to}
                element={<ReferenceBookDNATests/>}
            />
            <Route
                path={urlsConfig.referenceBookDefinitionOfSKUs.to}
                element={<ReferenceBookDefinitionOfSKUs/>}
            />
            <Route
                path={urlsConfig.referenceBookOrderStatuses.to}
                element={<ReferenceBookOrderStatuses/>}
            />
            <Route path={urlsConfig.referenceBookFamilySteps.to} element={<ReferenceBookFamilySteps/>}/>
            <Route path={urlsConfig.referenceBookAttributeSelectionRules.to}
                   element={<ReferenceBookAttributeSelectionRules/>}/>
            <Route path={urlsConfig.referenceBookAttributeRuleForNParticipants.to}
                   element={<ReferenceBookAttributeRuleForNParticipants/>}/>
            <Route path={urlsConfig.referenceBookDescribeKinshipSurvey.to}
                   element={<ReferenceBookDescribeKinshipSurvey/>}/>
            <Route path={urlsConfig.referenceBookPedigrees.to} element={<ReferenceBookPedigrees/>}/>
            <Route path={urlsConfig.referenceBookTestingAudience.to} element={<ReferenceBookAudience />} />
            <Route path={urlsConfig.referenceBookTestingState.to} element={<ReferenceBookState />} />
            <Route path={urlsConfig.referenceBookTestingQuestionType.to} element={<ReferenceBookQuestionType />} />
            <Route path={urlsConfig.referenceBookTestingReviewPeriod.to} element={<ReferenceBookReviewPeriod />} />
            <Route path={urlsConfig.referenceBookTestingAssignmentType.to} element={<ReferenceBookAssignmentType />} />
            <Route path={urlsConfig.referenceBookTestingRecipient.to} element={<ReferenceBookRecipient />} />
            <Route
                path={urlsConfig.referenceBookTestingPreviousAssignment.to}
                element={<ReferenceBookPreviousAssignment />}
            />
            <Route path={urlsConfig.referenceBookTestingUnit.to} element={<ReferenceBookUnit />} />
        </>
    );
}
